import { Account } from '@/components';
import { LanguageCode } from '@/interfaces';
import type { GetServerSideProps, InferGetServerSidePropsType, NextPage } from 'next';
import { NextSeo } from 'next-seo';

const AccountPage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = (props) => {
  return (
    <>
      <NextSeo
        title='Parcel Monitor'
        defaultTitle='Parcel Monitor'
        additionalLinkTags={[
          {
            rel: 'icon',
            href: '/favicons/favicon-32x32.png',
            type: 'image/png',
            sizes: '32x32',
          },
          {
            rel: 'icon',
            href: '/favicons/favicon-16x16.png',
            type: 'image/png',
            sizes: '16x16',
          },
        ]}
        additionalMetaTags={[
          {
            name: 'msapplication-TileColor',
            content: '#ffc03f',
          },
          {
            property: 'theme-color',
            content: '#ffffff',
          },
        ]}
      />
      <Account
        pmtOnboardingPopUp={props.pmtOnboardingPopUp}
        pmtEmailSyncOnboardingPopUp={props.pmtEmailSyncOnboardingPopUp}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  const languageCode = (params?.articleTypeSlug as LanguageCode) || LanguageCode.English;

  // If the language code is not valid, return 404
  if (!Object.values<string>(LanguageCode).includes(languageCode)) {
    return {
      notFound: true,
      props: {},
    };
  }

  return {
    props: {},
  };
};

export default AccountPage;
